
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import SelectComponent from '@/components/shared/Select.vue';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<CustomizeBeoModal>({
	components: {
		SelectComponent,
		StandardModal
	}
})
export default class CustomizeBeoModal extends Vue {
	@Prop({ type: Object, required: true }) private reportSections!: Record<string, boolean | Record<string, boolean>>;
	@Prop({ type: Object, required: true }) private order!: Order;
	@Prop({ type: Boolean, required: true }) private showModal!: boolean;

	private mutableReportSections: Record<string, boolean | Record<string, boolean>> | null = null;

	private get isTimelineSelected(): boolean {
		if (!this.mutableReportSections) {
			return false;
		}
		return Object.values(this.mutableReportSections.timeline as Record<string, boolean>).some(v => v);
	}

	private get timelineOptions(): { label: string, value: string }[] {
		return [
			{
				label: this.order.data.checkout.cateringEvent
					? this.$t('orders.beo.customize.event_start_end')
					: this.order.data.checkout.delivery ? this.$t('orders.beo.delivery_time') : this.$t('orders.beo.pickup_time'),
				value: 'eventStartEnd'
			},
			{ label: this.$t('orders.beo.customize.timepicker_external'), value: 'timepickerExternal' },
			{ label: this.$t('orders.beo.customize.timepicker_internal'), value: 'timepickerInternal' }
		];
	}

	private get selectedTimelineOptions(): string[] {
		if (!this.mutableReportSections?.timeline) {
			return [];
		}
		const timeline = this.mutableReportSections.timeline as Record<string, boolean>;
		return Object.keys(timeline).filter(key => timeline[key]);
	}

	private created(): void {
		this.mutableReportSections = cloneDeep(this.reportSections);
	}

	/**
	 * Toggle all timeline fields on or off.
	 *
	 * @return {void}
	 */
	private toggleTimeline(): void {
		if (!this.mutableReportSections) {
			return;
		}
		const allEnabled = !this.isTimelineSelected;
		this.mutableReportSections.timeline = {
			eventStartEnd: allEnabled,
			timepickerExternal: allEnabled,
			timepickerInternal: allEnabled
		};
	}

	/**
	 * Update the timeline report section based on selected options.
	 *
	 * @param {string[]} selected
	 * @return {void}
	 */
	private updateTimeline(selected: string[]): void {
		if (!this.mutableReportSections) {
			return;
		}
		this.mutableReportSections.timeline = {
			eventStartEnd: selected.includes('eventStartEnd'),
			timepickerExternal: selected.includes('timepickerExternal'),
			timepickerInternal: selected.includes('timepickerInternal')
		};
	}
}
